import * as React from "react";
import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  InputLabel,
  Paper,
  useTheme,
  TextField,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import Stack from "@mui/material/Stack";
// import { updateSeo } from "../../redux/Slices/addSeoSlice";
// import { getSelectedSeoDetail } from "../../redux/Slices/addSeoSlice";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateSEO } from "../../redux/Slices/extSlice";

export default function UpdateDetails({ setUpdate }) {
  const theme = useTheme();
  const { id } = useParams();
  const location = useLocation();
  const {
    title: prevTitle,
    desc: prevdesc,
    page: prevPage,
  } = location.state || {};
  console.log(prevTitle, prevdesc, prevPage, "data from prev");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [personName, setPersonName] = React.useState([]);
  const [iD, setID] = useState(null);
  const [title, setTitle] = useState(prevTitle);
  const [description, setDesc] = useState(prevdesc);
  const [data, setData] = useState(prevPage);
  // const getSelectedDetail = useSelector((state) => state.seo.testSeo);
  console.log(id, "iddddddddddd");

  const notify = (value) =>
    toast.success(value, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  const failure = (value) =>
    toast.error(value, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  // useEffect(() => {
  //   if (getSelectedDetail != null && getSelectedDetail.data.length > 0) {
  //     const firstSeo = getSelectedDetail.data[0];
  //     setID(firstSeo.id);
  //     setTitle(firstSeo.seotitle);
  //     setDesc(firstSeo.seodesc);
  //     setData(firstSeo.page);
  //   }
  // }, [getSelectedDetail]);

  function ComboBox({ onChange }) {
    return (
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={pageList}
        value={data}
        onChange={(event, newValue) => {
          onChange(newValue ? newValue.label : null);
        }}
        sx={{ width: "100%" }}
        renderInput={(params) => <TextField {...params} label="Select" />}
      />
    );
  }

  // Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
  const pageList = [
    { label: "/" },
    { label: "/about-us" },
    { label: "/contact-us" },
    { label: "/privacy-policy" },
    { label: "/terms-conditions" },
  ];
  // console.log(getSelectedDetail.data, "check");
  // console.log(title, "titlegetSelectedDetail");
  // console.log(id, "titlegetSelectedDetail");
  // console.log(description, "titlegetSelectedDetail");
  // console.log(data, "titlegetSelectedDetail");

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(title, "title");
    console.log(description, "desc");
    console.log(data, "data");
    const seodata = { id, title, desc: description, page: data };
    console.log(seodata, "seodata");
    dispatch(updateSEO(seodata))
      .then((response) => {
        console.log(response, "jhhjherlwjehr");
        if (response.payload.code == 201) {
          notify(response.payload.message);
          navigate("/seo");
        }
        if (response.payload.code == 400) {
          failure(response.payload.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

 return (
  <Box sx={{ pl: { xs: 0, md: "17%" }, pt: "90px", pb: 5 }}>
    {/* Heading */}
    <Typography
      variant="h5"
      fontWeight={600}
      sx={{ mb: 3, pl: { xs: 2, md: 4 } }}
    >
      Update SEO Details
    </Typography>

    {/* Form Container */}
    <Paper
      elevation={0}
      sx={{
        border: "1px solid #e5e5e5",
        borderRadius: "14px",
        p: { xs: 2, md: 4 },
        width: "90%",
        mx: "auto",
      }}
    >
      <form onSubmit={handleSubmit}>
        <Grid container spacing={4}>

          {/* SEO Title */}
          <Grid item xs={12} md={6}>
            <Typography fontWeight={500} mb={1}>
              SEO Title
            </Typography>
            <TextField
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Grid>

          {/* SEO Description */}
          <Grid item xs={12} md={6}>
            <Typography fontWeight={500} mb={1}>
              SEO Description
            </Typography>
            <TextField
              fullWidth
              value={description}
              onChange={(e) => setDesc(e.target.value)}
            />
          </Grid>

          {/* Page Name */}
          <Grid item xs={12} md={6}>
            <Typography fontWeight={500} mb={1}>
              Page Name
            </Typography>
            <TextField
              fullWidth
              disabled
              value={data}
            />
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12} textAlign="center" sx={{ mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              sx={{
                width: { xs: "100%", sm: "200px" },
                background: "linear-gradient(90deg,#6A4FE0,#7B6CFF)",
                py: 1.2,
                fontSize: "16px",
                borderRadius: "10px",
                textTransform: "none",
                "&:hover": {
                  background: "linear-gradient(90deg,#5a43c5,#6a59e8)",
                },
              }}
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>

    <ToastContainer />
  </Box>
);

}
